import React, { useState } from "react";

const ScrollableNoPagingDataTable = ({
  columns,
  data,
  getTrProps = () => {},
  buttonRow = null,
  minHeight = "350px",
  searchPlaceholder = "Search...",
  tableHeight = "400px",
}) => {
  const [search, setSearch] = useState("");

  // Filter data based on search input
  const filteredData = data.filter((row) =>
    columns.some((col) => {
      const value = row[col.accessor];
      return value
        ? value.toString().toLowerCase().includes(search.toLowerCase())
        : false;
    })
  );

  return (
    <div style={{ overflowX: "auto", minHeight }}>
      {/* Search */}
      <div className="mb-2">
        <input
          type="text"
          className="form-control"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Scrollable table */}
      <div style={{ maxHeight: tableHeight, overflowY: "auto" }}>
        <table className="table striped bordered hover">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.accessor}>{col.Header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className="table-hover-class"
                  style={{ cursor: "pointer" }}
                  onDoubleClick={(event) => getTrProps(event, row)}
                >
                  {columns.map((col) => (
                    <td key={col.accessor}>
                      {/* Check if column has a custom Cell */}
                      {col.Cell
                        ? col.Cell({ value: row[col.accessor], row })
                        : row[col.accessor] ?? ""}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  No record found
                </td>
              </tr>
            )}

            {/* Optional button row */}
            {buttonRow && (
              <tr>
                <td colSpan={columns.length}>{buttonRow}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScrollableNoPagingDataTable;
